import theme from '../../base';

const couponBox = {
  background: theme.colors.neutrals.white,
  foreground: theme.colors.greens.green500,
  border: theme.colors.neutrals.gray900,
  messageForeground: theme.colors.neutrals.gray700,
};

export default couponBox;
